export const formatPayRate = (value: string) => {
  return value
    .replace(/[^\d.]/g, '') // remove everything except digits
    .replace(/(\..*)\./g, '$1') // allow only the first decimal
    .replace(/^(\d+)(\.\d{0,2})?.*$/, '$1$2'); // limit to max 2 decimals
};
